import React from "react";

import BodyText from "Common/BodyText";
import { Card } from "Common/Card/";
import Icon from "Common/Icon";

const LoadingPlan = () => (
  <Card style={{ textAlign: "center", height: "80px" }} mt={2} mb={2}>
    <div>
      <Icon icon="spinner" spin="pulse" size="2x" mx="auto" />
      <BodyText agent pb={2}>
        Loading plan...
      </BodyText>
    </div>
  </Card>
);

export default LoadingPlan;
